export default __webpack_public_path__ + "static/media/min-amount.0770061e.svg";